<template>
<div v-loading="loading">
  <w-map-tree ref="mapTree" :class="$style['tree']"></w-map-tree>
  <!-- 지금은 ADMIN이 아니면 트리 편집 할 일이 없다. 하지만 추후 AMIN이 아니더라도 트리편집 할 경우가 생길 수 있으므로 참고하길 바람. -->
  <div v-if="!isEditMode">
    <el-row type="flex" justify="center" align="middle" :class="$style['btn-bar']" v-if="!isTreeEditMode">
      <span :class="[$style['tree-edit-btn'], 'c-pointer']" @click="onTreeEditClick">
        <i class="fas fa-sliders-h"></i>
        트리 편집
      </span>
    </el-row>
    <el-row type="flex" justify="center" align="middle" :class="$style['btn-bar']" v-else-if="isTreeEditMode">
      <el-button class="mr-r4" type="secondary" size="small" @click="onMapAddBtnClick" v-if="isSettingAuth"><i class="far fa-plus"></i>맵추가</el-button>
      <el-button class="mr-r4" size="medium" type="primary" @click="onSaveClick" v-if="!isSettingAuth">저장</el-button>
      <el-button size="medium" @click="onCancleClick">나가기</el-button>
    </el-row>
  </div>
  <el-popover
    placement="right"
    title="맵 숨기기"
    width="235"
    trigger="manual"
    v-model="tipVisible"
    popper-class="el-popover--plain">
    <div>
      <span>트리에서 보고 싶지 않은 맵이 있으면 체크하고 저장하세요.</span>
      <div style="margin-top: 10px;">
        <el-button @click="allCheck(true)"><i class="fas fa-check-square"></i> 모두 숨기기</el-button>
        <el-button @click="allCheck(false)"><i class="fas fa-square"></i> 모두 보이기</el-button>
      </div>
    </div>
    <span slot="reference" style="position: absolute; top: 50%; right: 0px;"></span>
  </el-popover>
</div>
</template>

<script>
import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import Base from '@/mixins/topologymap/base';

import msgUtil from '@/utils/message';

import WMapTree from '@/views/topologymap/components/MapTree';

export default {
  name: 'WMapList',
  components: {
    WMapTree,
  },
  mixins: [Base],
  data() {
    return {
      MapConst,
      updateTreeDataParam: [],
      index: 1,
      loading: false,
    };
  },
  computed: {
    tipVisible: {
      get() {
        return this.isTreeEditMode && !this.isSettingAuth;
      },
      set(value) {
        // ignore
      },
    },
  },
  methods: {
    onSaveClick() {
      this.$refs.mapTree.updateMapTreeShow();
    },
    /**
     * 트리 편집 버튼 클릭
     * 트리 편집 모드로 전환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onTreeEditClick() {
      this.$store.commit('setTopologymapViewMode', MapConst.VIEW_MODE.TREE_EDIT);
      // 장비주요정보 팝업창 close
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAJOR_INFO, null);
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, null);
    },
    /**
     * 취소 버튼 클릭
     * 모니터링 모드로 전환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onCancleClick() {
      this.$confirm(...msgUtil.getCustomConfirmData('나가시겠습니까?'))
        .then(() => {
          this.exit();
        })
        .catch(() => {});
    },
    /**
     * 트리 편집 모드 나가기
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    exit() {
      // 현재 토폴로지맵이 숨기기 처리 되었는지 확인하고, 숨기기 처리되어있다면 다른 맵을 로드하도록 한다.
      MapAPI.getMgrTopologymap(this.currentMapId).then((response) => {
        const result = response.data;

        if (result.success) {
          const isHideMap = result.data;

          // 숨기기 처리 되어있으면 다른 맵으로 이동시키기 위해 mapId를 -1로 수정
          if (isHideMap) {
            const panel = this.getTopologymapPanel();
            panel.getGraph().topologymapModel.mapId = -1;
          }
        }
      }).finally(() => {
        this.$store.commit('setTopologymapViewMode', MapConst.VIEW_MODE.MONITORING);
        this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.TREE_LOAD);
      });
    },
    /**
     * 맵 추가 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onMapAddBtnClick() {
      const panel = this.getTopologymapPanel();

      if (panel) {
        panel.$refs.mapPropertyPopup.open({
          type: 'ADD',
          treeData: this.$refs.mapTree.getTreeData(),
        });
      }
    },
    /**
     * 하위맵 추가 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onSubMapAddBtn() {
      const panel = this.getTopologymapPanel();

      if (panel) {
        panel.$refs.mapPropertyPopup.open({
          type: 'ADD_SUB',
        });
      }
    },
    /**
     * 맵 삭제 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onMapDeleteBtnClick() {
      this.$confirm(...msgUtil.getBasicConfirmData('맵을 삭제'))
        .then(() => {
          const mapId = this.mapTreeSelectedNode.mapId;

          MapAPI.deleteTopologymap(mapId).then((response) => {
            const result = response.data;

            if (result.success) {
              this.$message.success('맵을 삭제하였습니다.');

              // 맵이 새로고침 될 수 있도록 라우터를 변경한다.
              this.routeMap(-1, {
                redirect: true,
              });
              // 맵 트리 리로드
              this.treeLoad();
            } else {
              this.$message.error('맵을 삭제 못하였습니다.');
            }
          });
        })
        .catch(() => {});
    },
    /**
     * 토폴로지맵 패널을 찾는다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    getTopologymapPanel() {
      let parent = this.$parent;

      do {
        if (parent) {
          if (parent.$refs.topologymapPanel) {
            return parent.$refs.topologymapPanel;
          }
          parent = parent.$parent;
        }
      } while (parent);

      return null;
    },
    allCheck(hideFlag) {
      this.$refs.mapTree.allCheck(hideFlag);
    },
  },
};
</script>

<style module>
.tree {
  height: calc(100% - 55px) !important;
}
.tree-edit-btn {
  font-size: 15px;
  font-weight: 500;
  color: #999;
  height: 100%;
  width: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 55px;
}
.btn-bar {
  border-top: 1px solid #F0F0F0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/MapList.vue